// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_2787e5dfdf--spinner--1l2Wr","circle-spin":"_2787e5dfdf--circle-spin--BvxtL"};